import { useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue, SelectSeparator } from "./ui/select";
import QuickClientDialog from "./QuickClientDialog";

export default function ClientSelect({ value, clients, onPick, onCreated, testid }) {
  const [qc, setQc] = useState(false);
  return (
    <>
      <Select value={value || ""} onValueChange={(v) => { if (v === "__new") { setTimeout(() => setQc(true), 50); return; } onPick(clients.find((c) => c.id === v)); }}>
        <SelectTrigger data-testid={testid}><SelectValue placeholder="Seleziona cliente" /></SelectTrigger>
        <SelectContent onCloseAutoFocus={(e) => e.preventDefault()} className="max-h-72">
          <SelectItem value="__new" data-testid={`${testid}-new`} className="text-brand font-semibold">+ Nuovo cliente</SelectItem>
          <SelectSeparator />
          {clients.filter((c) => c.id).map((c) => <SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>)}
        </SelectContent>
      </Select>
      <QuickClientDialog open={qc} onClose={() => setQc(false)} onSelect={(c) => { if (!clients.some((x) => x.id === c.id)) onCreated(c); onPick(c); }} />
    </>
  );
}
